import * as Yup from 'yup';

export const DetailSchema = Yup.object().shape({
  'First-Name': Yup.string().required(),
  'Last-Name': Yup.string().required(),
  Email: Yup.string().required()
});
